import { render } from "./GrapesJSRender.vue?vue&type=template&id=324068f2"
import script from "./GrapesJSRender.vue?vue&type=script&lang=js"
export * from "./GrapesJSRender.vue?vue&type=script&lang=js"

import "./GrapesJSRender.vue?vue&type=style&index=0&id=324068f2&lang=css"
script.render = render

export default script